import React from 'react'
import { WidgetProps } from 'react-jsonschema-form'

import TextWidget from './TextWidget'

const EmailWidget = ({ options: givenOptions, ...props }: WidgetProps) => {
  return <TextWidget {...props} options={{ ...givenOptions, inputType: 'email' }} />
}

export default EmailWidget
